module.exports = __webpack_public_path__ + "static/media/banner_uno.559efe4b.png";